<template>
  <v-card flat>
    <dialogSauvegardeRecherche
      ref="dialogSauvegardeRecherche"
      @change="rechercheSauvegardee"
    />

    <dialogSupprimeRecherche
      ref="dialogSupprimeRecherche"
      @delete="rechercheSupprimee"
    />

    <v-list-item two-line class="pt-0">
      <v-list-item-content>
        <v-list-item-title class="headline"
          >Recherche avancée
        </v-list-item-title>
        <v-list-item-subtitle
          >Répondant aux critères suivants</v-list-item-subtitle
        >
      </v-list-item-content>

      <v-list-item-action class="d-print-none" v-if="envoiEnabled">
        <envoi-message
          :typeObjet="this.typeObjet"
          :selectedContacts="selectedContact"
          :recherche="elementsRecherche"
          :nbContacts="selectedContact.length"
        />
      </v-list-item-action>

      <v-list-item-action class="d-print-none" v-if="rappelLoginEnabled">
        <envoi-rappel-login
          :recherche="selectedContact"
          :nbContacts="selectedContact.length"
        />
      </v-list-item-action>

      <v-list-item-action class="d-print-none" v-if="rappelLoginEnabled">
        <envoi-rappel-instance
          :recherche="selectedContact"
          :nbContacts="selectedContact.length"
        />
      </v-list-item-action>

      <v-list-item-action v-if="rechercheSelectionnee">
        <v-chip color="secondary" outlined label
          >{{ infoRecherche.titre }}
          <template v-if="rechercheSale">*</template></v-chip
        >
      </v-list-item-action>

      <v-list-item-action class="d-print-none">
        <v-menu offset-y>
          <template #activator="{ on:onMenu}">
            <v-tooltip bottom>
              <template #activator="{ on: onTooltip }">
                <v-btn icon v-on="{ ...onMenu, ...onTooltip }">
                  <v-icon>mdi-floppy </v-icon>
                </v-btn>
              </template>

              <span>Sauvegarder</span>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item
              :disabled="rechercheNonSauvegardable"
              @click="sauvegardeRecherche"
            >
              <v-list-item-title>Sauvegarder la recherche</v-list-item-title>
            </v-list-item>

            <v-list-item
              :disabled="!rechercheSelectionnee"
              @click="supprimerRecherche"
            >
              <v-list-item-title>Supprimer la recherche</v-list-item-title>
            </v-list-item>

            <v-list-item
              :disabled="!rechercheSelectionnee"
              @click="nouvelleRecherche"
            >
              <v-list-item-title>Nouvelle recherche</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-list-item-action>
      <v-list-item-action class="d-print-none">
        <export
          :typeObjet="this.typeObjet"
          typeRecherche="avancee"
          :datasourceContact="datasourceContact"
          :datasourcePersonneMorale="datasourcePersonneMorale"
          :datasourceInstance="datasourceInstance"
          :selectedContact="selectedContact"
          :selectedPersonneMorale="selectedPersonneMorale"
          :selectedInstance="selectedInstance"
        />
      </v-list-item-action>
      <v-list-item-action class="ml-0 d-print-none">
        <printButton />
      </v-list-item-action>
    </v-list-item>

    <v-card-text class="pb-0">
      <parametresRechercheAvancee
        ref="parametres"
        :initial="recherche"
        @change="rechercheChange"
        class="px-3"
      />
    </v-card-text>

    <v-divider class="mx-4" />

    <v-card-text>
      <v-tabs @change="changeTab" v-model="tab" color="primary">
        <v-tab @click="tabPersonnePhysique()">
          {{ this.$t('recherche.rechercheSimple.tabs.contact') }}
        </v-tab>

        <v-tab @click="tabPersonneMorale()">
          {{ this.$t('recherche.rechercheSimple.tabs.personneMorale') }}
        </v-tab>

        <v-tab @click="tabInstance()">
          {{ this.$t('recherche.rechercheSimple.tabs.instance') }}
        </v-tab>

        <v-tab-item>
          <datasource-table
            :datasource="datasourceContact"
            :tableProps="{ showSelect: true }"
            v-model="selectedContact"
            @paginate="storeRecherche"
          >
            <template #item.raisonSociale="{item}">
              <navigable-link
                :to="$liens().personneMorale(item.idPersonneMorale)"
                >{{ item.raisonSociale }}
              </navigable-link>
            </template>

            <template #item.nom="{item}">
              <navigable-link
                :to="
                  $liens().personnePhysique(item.idPersonnePhysique, item.id)
                "
              >
                {{ item.nom }}
              </navigable-link>
            </template>
            <template #item.prenoms="{item}">
              <navigable-link
                :to="
                  $liens().personnePhysique(item.idPersonnePhysique, item.id)
                "
              >
                {{ item.prenoms }}
              </navigable-link>
            </template>

            <template #item.telephone="{item}">
              <span class="text-no-wrap">{{
                getInternational(item.telephone)
              }}</span>

              <v-tooltip v-if="item.telephoneConfidentiel" bottom>
                <template #activator="{ on }">
                  <v-icon v-on="on">mdi-eye-off</v-icon>
                </template>
                <span>Confidentiel</span>
              </v-tooltip>
            </template>

            <template #item.mail="{item}">
              {{ item.mail }}
              <v-tooltip v-if="item.mailConfidentiel" bottom>
                <template #activator="{ on }">
                  <v-icon v-on="on">mdi-eye-off</v-icon>
                </template>
                <span>Confidentiel</span>
              </v-tooltip>
            </template>
          </datasource-table>

          <div
            class="d-flex"
            v-if="$auth.hasRole('PRIV_PERSONNE_PHYSIQUE_WRITE')"
          >
            <v-spacer />
            <v-btn
              small
              outlined
              color="secondary"
              :disabled="datasourceContact.items.length < 2"
              @click="demarreModifMasse"
              >Modification de masse</v-btn
            >
          </div>
        </v-tab-item>

        <v-tab-item>
          <datasource-table
            :datasource="datasourcePersonneMorale"
            :tableProps="{ showSelect: true }"
            v-model="selectedPersonneMorale"
            @paginate="storeRecherche"
          >
            <template #item.nomUsuel="{item}">
              <navigable-link :to="$liens().personneMorale(item.id)">
                {{ item.nomUsuel }}
              </navigable-link>
            </template>
            <template #item.raisonSociale="{item}">
              <navigable-link :to="$liens().personneMorale(item.id)">
                {{ item.raisonSociale }}
              </navigable-link>
            </template>
            <template #item.telephone="{item}">
              <span class="text-no-wrap">{{
                getInternational(item.telephone)
              }}</span>
            </template>
          </datasource-table>

          <div
            class="d-flex"
            v-if="$auth.hasRole('PRIV_PERSONNE_MORALE_WRITE')"
          >
            <v-spacer />
            <v-btn
              small
              outlined
              color="secondary"
              :disabled="datasourcePersonneMorale.items.length < 2"
              @click="demarreModifMasse"
              >Modification de masse</v-btn
            >
          </div>
        </v-tab-item>
        <v-tab-item>
          <datasource-table
            :datasource="datasourceInstance"
            :tableProps="{ showSelect: true }"
            v-model="selectedInstance"
            @paginate="storeRecherche"
          >
            <template #item.nom="{item}">
              <navigable-link :to="$liens().instance(item.id)">
                {{ item.nom }}
              </navigable-link>
            </template>
          </datasource-table>

          <div class="d-flex" v-if="$auth.hasRole('PRIV_INSTANCE_WRITE')">
            <v-spacer />
            <v-btn
              small
              outlined
              color="secondary"
              :disabled="datasourceInstance.items.length < 2"
              @click="demarreModifMasse"
              >Modification de masse</v-btn
            >
          </div>
        </v-tab-item>
      </v-tabs>
    </v-card-text>

    <dialogModifMasse
      ref="dialogModifMasse"
      @valide="refreshApresModificationbMasse"
    />
  </v-card>
</template>

<script>
import Datasource from '@/utils/datasource';
import toasted from '@/utils/toasted';
import _ from 'lodash';
import { getInternational } from '@/components/telephone/telephoneUtil.js';

export default {
  data() {
    const store = this.$store.state.rechercheavancee;

    const datasourceContact = new Datasource(
      'recherche/avancee/personne-physique',
      {
        body: {},
        page: 1,
        rowsPerPage: 20,
        sortBy: ['nom'],
        descending: [false],
        selectAll: this.selectAll,
        labelNamespace: 'recherche.rechercheSimple.personnePhysique.list',
        fields: [
          {
            value: 'nom',
            sortable: true,
          },
          {
            value: 'prenoms',
            sortable: true,
          },
          {
            value: 'raisonSociale',
            sortable: true,
            text: this.$t(
              'recherche.rechercheSimple.personnePhysique.list.headers.personneMorale',
            ),
          },
          {
            value: 'fonction',
            sortable: true,
            text: this.$t(
              'recherche.rechercheSimple.personnePhysique.list.headers.fonction',
            ),
          },
          {
            value: 'telephone',
            sortable: false,
            text: this.$t(
              'recherche.rechercheSimple.personnePhysique.list.headers.telephone',
            ),
          },
          {
            value: 'mail',
            sortable: false,
            text: this.$t(
              'recherche.rechercheSimple.personnePhysique.list.headers.mail',
            ),
          },
        ],
      },
    );

    const datasourcePersonneMorale = new Datasource(
      'recherche/avancee/personne-morale',
      {
        body: {},
        page: 1,
        rowsPerPage: 20,
        sortBy: ['nomUsuel'],
        descending: [false],
        labelNamespace: 'recherche.rechercheSimple.personneMorale.list',
        fields: [
          {
            value: 'nomUsuel',
            sortable: true,
          },
          {
            value: 'raisonSociale',
            sortable: true,
          },
          {
            value: 'departement',
            sortable: false,
          },
          {
            value: 'ville',
            sortable: false,
          },
          {
            value: 'telephone',
            sortable: false,
          },
        ],
      },
    );

    const datasourceInstance = new Datasource('recherche/avancee/instance', {
      body: {},
      page: 1,
      rowsPerPage: 20,
      sortBy: ['nom'],
      descending: [false],
      labelNamespace: 'recherche.rechercheSimple.instance.list',
      fields: [
        {
          value: 'nom',
          sortable: true,
          text: this.$t('recherche.rechercheSimple.instance.list.headers.nom'),
        },
        {
          value: 'referent',
          sortable: true,
          text: this.$t(
            'recherche.rechercheSimple.instance.list.headers.referent',
          ),
        },
        {
          value: 'nomsGestionnaires',
          sortable: false,
          text: this.$t(
            'recherche.rechercheSimple.instance.list.headers.personnePhysique',
          ),
        },
        {
          value: 'size',
          sortable: false,
          text: this.$t(
            'recherche.rechercheSimple.instance.list.headers.numberOfUser',
          ),
        },
      ],
    });

    if (store.tab >= 0 && store.pagination) {
      const pagination = JSON.parse(JSON.stringify(store.pagination));
      if (store.tab === 0) {
        datasourceContact.pagination = pagination;
      } else if (store.tab === 1) {
        datasourcePersonneMorale.pagination = pagination;
      } else if (store.tab === 2) {
        datasourceInstance.pagination = pagination;
      }
    }

    var infoRecherche = this.$route.params.infoRecherche;

    var recherche = null;
    if (infoRecherche) {
      recherche = infoRecherche.recherche;
    } else if (store.recherche && store.recherche.length) {
      recherche = JSON.parse(JSON.stringify(store.recherche));
      infoRecherche = JSON.parse(JSON.stringify(store.infoRecherche));
    }

    return {
      recherche,
      tab: store.recherche ? store.tab : 0,
      datasourceContact,
      datasourcePersonneMorale,
      datasourceInstance,
      // Les v-model des 3 DatasourceTable
      selectedContact: [],
      selectedPersonneMorale: [],
      selectedInstance: [],
      // L'onglet sélectionné
      typeObjet: 'contact',
      dialogModifMasse: false,
      infoRecherche: {
        id: infoRecherche ? infoRecherche.id : null,
        titre: infoRecherche ? infoRecherche.titre : null,
        recherche: infoRecherche ? infoRecherche.recherche : null,
      },
    };
  },
  computed: {
    rechercheSale() {
      return !_.isEqual(this.recherche, this.infoRecherche.recherche);
    },
    rechercheNonSauvegardable() {
      return !this.recherche;
    },
    rechercheSelectionnee() {
      return this.infoRecherche.id !== null;
    },

    datasource() {
      if (this.tab == 0) {
        return this.datasourceContact;
      } else if (this.tab == 1) {
        return this.datasourcePersonneMorale;
      } else if (this.tab == 2) {
        return this.datasourceInstance;
      }

      return null;
    },
    datasourcePagination() {
      if (this.datasource != null) {
        return this.datasource.pagination;
      }

      return null;
    },
    // Pour vérifier si le bouton Envoi doit êre affiché
    envoiEnabled() {
      return this.typeObjet === 'contact' && this.$auth.hasRole('PRIV_ENVOI');
    },

    rappelLoginEnabled() {
      return (
        this.typeObjet === 'contact' && this.$auth.hasRole('PRIV_RAPPEL_LOGIN')
      );
    },

    elementsRecherche() {
      //conversion des enumerations en mode lazy
      if (this.recherche) {
        return this.recherche.map(e => {
          if (e.valeur && e.valeur.libelle) {
            return {
              ...e,
              valeur: e.valeur.id,
            };
          }
          return e;
        });
      }
      return null;
    },

    nbContacts() {
      return this.datasourceContact.totalRows;
    },
  },
  created() {
    // On se positionne sur l'onglet éventuellement demandé
    if (this.$route.params.tab) {
      let tabParam = this.$route.params.tab;
      switch (this.$route.params.tab) {
        case 'contact':
          this.tab = 0;
          this.typeObjet = tabParam;
          break;
        case 'personneMorale':
          this.tab = 1;
          this.typeObjet = tabParam;
          break;
        case 'instance':
          this.tab = 2;
          this.typeObjet = tabParam;
          break;
      }
    } else if (this.$store.state.rechercheavancee.tab) {
      let tabStore = this.$store.state.rechercheavancee.tab;
      switch (tabStore) {
        case 1:
          this.typeObjet = 'personneMorale';
          break;
        case 2:
          this.typeObjet = 'instance';
          break;
      }
    }
  },
  mounted() {
    this.refreshDataSource(false);
    if (this.infoRecherche.recherche) {
      this.storeRecherche();
    }

    this.$store.commit('origine/recherche', {
      recherche: 'rechercheavancee',
    });
  },
  methods: {
    refreshApresModificationbMasse() {
      this.refreshDataSource(false);
    },
    changeTab() {
      this.refreshDataSource(false);
      this.storeRecherche();
    },
    rechercheChange(evt) {
      this.recherche = evt;
      this.refreshDataSource(true);
      this.storeRecherche();
    },
    refreshDataSource(debounced) {
      if (this.datasource) {
        var elements = this.elementsRecherche;
        if (elements !== null) {
          this.datasource.body = {
            elements,
          };

          if (debounced) {
            //on est debounced quand on provient d'un changement dans la recherche
            this.datasource.pagination.page = 1;
            this.datasource.debouncedRefresh();
          } else {
            this.datasource.refresh();
          }
        } else {
          this.datasource.body = {};
          this.datasource.clear();
        }
      }
    },
    demarreModifMasse() {
      const nb = this.datasource.totalRows;
      this.$refs.dialogModifMasse.show(
        this.tab,
        nb,
        this.$refs.parametres.enums,
        this.recherche,
      );
    },
    storeRecherche() {
      const recherche = JSON.parse(JSON.stringify(this.recherche));
      const pagination = JSON.parse(JSON.stringify(this.datasourcePagination));
      const tab = JSON.parse(JSON.stringify(this.tab));
      const infoRecherche = JSON.parse(JSON.stringify(this.infoRecherche));

      this.$store.commit('rechercheavancee/sauvegardeRecherche', {
        recherche,
        pagination,
        tab,
        infoRecherche,
      });
    },
    sauvegardeRecherche() {
      const recherche = JSON.parse(JSON.stringify(this.recherche));

      const infoRecherche = {
        id: this.infoRecherche.id,
        titre: this.infoRecherche.titre,
        recherche,
      };
      this.$refs.dialogSauvegardeRecherche.afficher(infoRecherche);
    },
    supprimerRecherche() {
      this.$refs.dialogSupprimeRecherche.afficher(this.infoRecherche.id);
    },
    nouvelleRecherche() {
      this.infoRecherche.id = null;
      this.infoRecherche.titre = null;
      this.infoRecherche.recherche = null;

      this.$refs.parametres.supprimerClauses();

      this.storeRecherche();
    },
    rechercheSauvegardee(infoRecherche) {
      this.infoRecherche.id = infoRecherche.id;
      this.infoRecherche.titre = infoRecherche.titre;
      this.infoRecherche.recherche = infoRecherche.recherche;

      this.storeRecherche();
    },
    rechercheSupprimee() {
      this.nouvelleRecherche();
      toasted.info('La recherche a été supprimée');
    },
    getInternational,
    tabPersonnePhysique() {
      this.typeObjet = 'contact';
    },
    tabPersonneMorale() {
      this.typeObjet = 'personneMorale';
    },
    tabInstance() {
      this.typeObjet = 'instance';
    },
  },
};
</script>
